import { usePermissions } from "@Context/common/permissions/permissions";
import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { TextFieldProps } from "@mui/material";
import { StyledTextFieldAlt } from "./styled-components";

const BybTextFieldAlt = (props: TextFieldProps) => {
  const permissions = usePermissions?.();
  const isDisabled = permissions?.canEdit === false || !!props.disabled;

  return (
    <StyledTextFieldAlt 
      {...props} 
      disabled={isDisabled}
      SelectProps={{
        IconComponent: KeyboardArrowDownRounded,
        ...props.SelectProps
      }}
    />
  );
};

export default BybTextFieldAlt;
